import { styled } from "@mui/material/styles";

export const XAxisGroup = styled("g")(({ theme }) => ({
  fontSize: 12,
  color: theme.vars.palette.texts.neutral.subtle,
  "& > .domain": {
    stroke: theme.vars.palette.divider,
    strokeWidth: 2,
  },
  "& > .tick > line": {
    stroke: theme.vars.palette.divider,
    strokeWidth: 1,
  },
}));
